module.exports = __webpack_public_path__ + "img/galery12.b3180083.jpg";